
import { NoseurObject } from "@rivtn/noseur";
import { SanitizedResponse } from "../BaseService";
import { HeraBaseService, ISupportPlatform } from "./HeraBaseService";

export interface IFaq {
    title: string;
    content: string;
    language: string;
    platform_id: string;
    external_id: string;
    platform: ISupportPlatform;
}

export class FaqService extends HeraBaseService {

    protected static instance: FaqService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!FaqService.instance) FaqService.instance = new FaqService();
        return FaqService.instance;
    }

    queryFaqs(params: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<SanitizedResponse<IFaq>> {
        params["platform.platform_id"] = params.platform_id;
        delete params.platform_id;
        return this.report(this.transport.get("/hera/api/v1/faq", { query: this.normalizeParams(params) }));
    }

    createFaq(faq: Partial<IFaq>): Promise<SanitizedResponse<IFaq>> {
        return this.report(this.transport.post("/hera/api/v1/faq", faq));
    }

    updateFaq(faq: Partial<IFaq>): Promise<SanitizedResponse<IFaq>> {
        return this.report(this.transport.patch(`/hera/api/v1/faq/${faq.external_id}`, faq));
    }

    deleteFaq(id: string): Promise<SanitizedResponse<IFaq>> {
        return this.report(this.transport.delete(`/hera/api/v1/faq/${id}`));
    }

}

